<template>
  <div class="distribute-notice" :style="style" @click="showModel">
    <van-popup
      v-model="show"
      :close-on-click-overlay="false"
      @click-overlay="hiddenModel($event)"
      overlay-class="more-btn-overlay"
      class="more-btn-wrap"
    >
      <div class="notice">
        <div class="top"></div>
        <p v-if="content">{{content}}</p>
        <slot name="content"></slot>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "DistributeNotice",
  props: {
    noticeStyle: {
      type: Object,
      default: () => {
        return {
          right: "24px",
          top: "24px"
        };
      }
    },
    imgUrl: {
      type: String,
      default: require("@/assets/images/distribute/withdraw-notice.png")
    },
    content: {
      type: String,
      default: "iOS端不支持提现，请前往其他终端操作"
    }
  },
  computed: {
    style() {
      return {
        backgroundImage: `url(${this.imgUrl})`,
        right: this.noticeStyle.right,
        top: this.noticeStyle.top
      };
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    showModel(event) {
      if (event.target.className == "distribute-notice") {
        this.show = true;
      }
    },
    hiddenModel() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.distribute-notice {
  position: absolute;
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /deep/ .van-overlay {
    background: none;
  }
  /deep/ .more-btn-wrap {
    overflow-y: visible;
    transform: translate(-100%, 0);
    position: static;
    > div {
      overflow: visible;
      box-shadow: 0px 0px 26px -4px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      padding: 18px 16px;
      color: #646464;
      font-size: 24px;
      line-height: 32px;
      position: absolute;
      background: #fff;
      top: 50px;
      right: -40px;
      width: 210px;
      .top {
        position: absolute;
        right: 34px;
        top: -20px;
      }
      .top:before,
      .top:after {
        position: absolute;
        content: "";
        border-top: 10px transparent dashed;
        border-left: 10px transparent dashed;
        border-right: 10px transparent dashed;
        border-bottom: 10px #fff solid;
      }
      .top:before {
        border-bottom: 10px #0099cc solid;
      }
      .top:after {
        top: 1px; /*覆盖并错开1px*/
        border-bottom: 10px #fff solid;
      }
    }
  }
}
</style>
